export default {
  // App root data
  data() {
    return {
      foo: 'bar'
    };
  },

  // App root methods
  methods: {
    doSomething() {// ...
    }

  },
  id: 'ce3a8881cc',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div id=app><!-- Your main view, should have "view-main" class --><div class="view view-main view-init safe-areas" data-url=/ ></div><div id=zoom-toggle class=""><span class="material-icons zoom-in">zoom_in </span><span class="material-icons zoom-out">zoom_out</span></div><div class="popup popup-politicas"><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=right><a class="link popup-close"><i class=f7-icons>multiply_close</i></a></div><div class=title>Políticas de Privacidad</div></div></div><div class=block><!-- <p><b>Políticas de Privacidad</b></p> --><!-- Close Popup --><!-- <p><a class="link popup-close" href="#">Cerrar</a></p> --><p><b>CONSORCIO CONSTRUCTOR SALTILLO SA DE CV</b>se compromete a asegurar la privacidad de la información personal obtenida a través de sus servicios en línea. Le sugerimos leer la informativa descrita a continuación, para entender el tratamiento de su información personal.</p><p><b>¿Qué tipo de información se obtiene?</b></p><p><b>CONSORCIO CONSTRUCTOR SALTILLO SA DE CV</b>obtenemos información de diferentes maneras, desde diferentes áreas de nuestro sitio Web. Se solicita información como:<br><br>Nombre(s) y Apellidos.<br>Correo Electrónico.<br>Teléfono.</p><p><b>¿Cómo se utiliza su información?</b></p><p>El objetivo más importante es conocer a nuestros visitantes para poder proporcionarles productos o servicios acordes a sus necesidades, así como contenidos y publicidad más adecuados.</p><p><b>Confidencialidad de la información.</b></p><p>Sólo se podrá difundir información en casos especiales, cuando pueda servir para identificar, localizarlo realizar acciones legales contra personas que pueden infringir las condiciones del servicio de nuestro sitio Web o causar daños algunos sobre los derechos de <b>nuestra compañía</b> o sus propiedades, así como de otros usuarios del portal o de cualquier otra persona que pudiese resultar perjudicada por dichas actividades.</p><p><b>CONSORCIO CONSTRUCTOR SALTILLO SA DE CV</b>no compartirá la información confidencial con terceras partes, a excepción de que se tenga expresa autorización de quienes se suscribieron o cuando haya sido requerido por orden judicial para cumplir con las disposiciones procesales.</p><p>Nos reservamos el derecho de realizar en cualquier momento, modificaciones en la presente política de privacidad y adaptarla a novedades legislativas, jurisprudenciales, así como practicas del mercado. Queda bajo responsabilidad del usuario leer periódicamente las Políticas de Privacidad para estar al tanto de posibles modificaciones. Una vez introducida en el sitio Web, la modificación entrará automáticamente en vigencia.</p><p>Actualización Septiembre del 2020.</p></div></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};